import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from '@/context/LanguageContext';
import { MenuDataProvider } from '@/context/MenuDataContext';
import { Toaster } from '@/components/ui/sonner';
import WelcomeScreen from '@/components/WelcomeScreen';
import MenuCategories from '@/components/MenuCategories';
import CategoryDetail from '@/components/CategoryDetail';
import QRCodePage from '@/components/QRCodePage';
import AdminPanel from '@/components/AdminPanel';
import '@/App.css';

// Maintenance Mode - Set to false to enable all pages
const MAINTENANCE_MODE = false;

function App() {
  return (
    <LanguageProvider>
      <MenuDataProvider>
      <div className="App">
        <Toaster position="top-center" richColors />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<WelcomeScreen />} />
            {MAINTENANCE_MODE ? (
              <>
                <Route path="/menu" element={<Navigate to="/" replace />} />
                <Route path="/menu/:categoryId" element={<Navigate to="/" replace />} />
                <Route path="/qr" element={<Navigate to="/" replace />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            ) : (
              <>
                <Route path="/menu" element={<MenuCategories />} />
                <Route path="/menu/:categoryId" element={<CategoryDetail />} />
                <Route path="/qr" element={<QRCodePage />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </>
            )}
          </Routes>
        </BrowserRouter>
      </div>
      </MenuDataProvider>
    </LanguageProvider>
  );
}

export default App;
